import { Box } from '@mui/material'
import classNames from 'classnames'
import { TextInput } from 'packages/eid-ui'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import FieldItemWrapper from '../Components/FieldItemWrapper'
import RequiredFieldErrorMessage from '../Components/FieldItemWrapper/RequiredFieldErrorMessage'
import {
    FIELD_TYPE_COMPONENTS_TYPES,
    getFieldTypeRequiredErrorMessage,
} from 'packages/core'

const FixedSingleValue = ({
    fieldType,
    isFormValidated,
    valueType,
    handleUpdate,
}) => {
    const { t } = useTranslation()
    const [errorMessage, setErrorMessage] = useState('')

    useEffect(() => {
        if (isFormValidated && !fieldType?.[valueType]) {
            setErrorMessage(getFieldTypeRequiredErrorMessage(fieldType))
        } else {
            setErrorMessage('')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isFormValidated, fieldType?.[valueType]])

    const handleChange = (value) => {
        try {
            const valueToUpdate = {
                ...fieldType,
                [valueType]: { ValueName: value },
            }
            handleUpdate(valueToUpdate)
        } catch (err) {}
    }

    const isReadOnly = () => {
        return (
            fieldType?.SelectionRule ===
                FIELD_TYPE_COMPONENTS_TYPES.FIXED_SINGLE_VALUE ||
            fieldType.IsReadOnly
        )
    }
    return (
        <FieldItemWrapper
            title={fieldType?.Name}
            isRequired={fieldType?.IsRequired}
            fieldTypeScope={fieldType?.FieldTypeScope}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '2rem',
                    boxShadow: '0 .4rem .6rem -0.2rem rgba(0, 0, 0, 0.1)',
                    '& input': {
                        maxWidth: '36rem',
                        color: '#3b454d',
                    },
                    '& .MuiBox-root': {
                        maxWidth: '36rem',
                        width: '100%',
                    },
                    '& .MuiFormControl-root': {
                        marginTop: '0 !important',
                        maxWidth: '36rem',
                        borderRadius: '.4rem',
                    },

                    '& .MuiInputBase-formControl': {
                        minWidth: '36rem',
                    },
                    ...(Boolean(errorMessage) && {
                        '& input': {
                            outline: '0.1rem solid #d0021b',
                        },
                    }),
                    ...(isReadOnly() && {
                        pointerEvents: 'none',
                        opacity: '.6',
                        cursor: 'not-allowed',
                    }),
                }}
            >
                <TextInput
                    handleChange={handleChange}
                    value={fieldType?.[valueType]?.ValueName || ''}
                    placeholder={t('Common_EnterValue')}
                    disabled={isReadOnly()}
                />
            </Box>
            <Box>
                {Boolean(errorMessage) && (
                    <RequiredFieldErrorMessage errorMsgKey={errorMessage} />
                )}
            </Box>
        </FieldItemWrapper>
    )
}

export default FixedSingleValue
